import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { apiurl } from "../config/config";
import { BiError } from "react-icons/bi";
import { BlinkLoader } from "../components/loader";
import { setCookie } from "../config/webStorage.js";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useUser } from "../config/userProvider";
// import logo from "../logo.png";
// import { FcGoogle } from "react-icons/fc";
// import { FaFacebook } from "react-icons/fa6";
// import svg from "../components/svg";
// import { BsChatFill, BsSend } from "react-icons/bs";
// import { MdClose } from "react-icons/md";
// import { IoLogoAndroid } from "react-icons/io";
// import { DiApple } from "react-icons/di";
// import { RiMobileDownloadLine } from "react-icons/ri";
// import { toast } from "react-toastify";

const UserLogin = () => {
  const { token } = useUser();
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loginloading, setloginloading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  // const [isOpen, setIsOpen] = useState(false); // State to toggle chat window
  const [rememberMe, setRememberMe] = useState(false);

  const handleCheckboxChange = (e) => {
    setRememberMe(e.target.checked);
  };

  const navigate = useNavigate();

  // useEffect(() => {
  //   if (token) {
  //     navigate("/dashboard");
  //   }
  // }, [token]);
  useEffect(() => {
    if (token) {
      navigate("/dashboard");
    }
  }, [token, navigate]);

  //   const loginHandler = async (e) => {
  //     e.preventDefault();
  //     if (!email) return setError("Please enter email address");
  //     if (!password) return setError("Please enter password");
  //     try {
  //       setloginloading(true);
  //       const response = await axios.post(`${apiurl}/admin/v1/user/login`, {
  //         email,
  //         password,
  //       });
  //       if (!response.data.success) {
  //         setError(response.data.message);
  //       } else {
  //         const loginToken = response.data.token;

  //         if (rememberMe) {
  //           setCookie("sctoken", loginToken, 50 * 1200);

  //         } else {
  //           localStorage.setItem("loginToken", loginToken);
  //         }
  //       }
  //       navigate("/dashboard");
  //     }
  //     } catch (error) {
  //     setError("Login failed. Please try again.");
  //   } finally {
  //     setloginloading(false);
  //   }
  // };

  const loginHandler = async (e) => {
    e.preventDefault();
    if (!email) return setError("Please enter email address");
    if (!password) return setError("Please enter password");

    try {
      setloginloading(true);
      const response = await axios.post(`${apiurl}/admin/v1/user/login`, {
        email,
        password,
      });

      if (!response.data.success) {
        setError(response.data.message);
      } else {
        const loginToken = response.data.token;

        if (rememberMe) {
          setCookie("sctoken", loginToken, 50 * 1200);
        } else {
          sessionStorage.setItem("loginToken", loginToken); // Changed to sessionStorage
        }

        navigate("/dashboard");
      }
    } catch (error) {
      setError("Login failed. Please try again.");
    } finally {
      setloginloading(false);
    }
  };

  // const handleDownload = () => {
  //   const link = document.createElement('a');
  //   link.href = '/app-release.apk';
  //   link.download = 'inficonnect.apk';
  //   link.click();
  // };
  return (
    // <div className="w-[100vw] h-[100vh] flex justify-center align-middle items-center p-2">
    //   <div className="w-full h-full xl:max-h-[600px] md:w-[90%] xl:w-[70%] md:h-[80%] mx-auto border border-slate-300 rounded-xl md:shadow-md ">
    //     <div className="rounded-lg  md:w-[100%] mx-auto  md:h-screen-xl w-full h-full flex flex-col md:flex-row">
    //       <div className="w-full md:w-1/2 h-full  md:flex flex-col  justify-center pr-[5%] items-start hidden ">
    //         <div
    //           className=" flex flex-col justify-between h-full relative w-[100%]  rounded-xl"
    //           style={{
    //             background:
    //               "linear-gradient(156.97deg, #9089FF 14.91%, #CECBFF 58.52%, #FFFFFF 93.18%)",
    //           }}
    //         >
    //           <div className="flex flex-col w-full  justify-start align-middle items-center mt-5 h-full">
    //           </div>
    //           <div className="flex absolute bottom-0 -right-[40%] justify-center w-auto h-[70%]">
    //             <img src="/loginBackground.png" alt="Logo" className=" " />
    //           </div>
    //         </div>
    //       </div>
    //       <div className="w-full md:w-1/2 h-full flex flex-col justify-center  md:pl-[5%] items-center">
    //         <div className="max-w-md">
    //           <div className="flex  justify-center w-full">
    //             <img src="/logo.png" alt="Logo" className="h-10 mb-6 " />
    //           </div>
    //           <h2 className="text-xl md:text-2xl font-semibold text-center text-gray-800 mb-2">
    //             Login in to your account
    //           </h2>
    //           <p className="text-gray-500 text-center mb-8">
    //             Please enter your Login ID and Password
    //           </p>

    //           <form onSubmit={loginHandler} className="space-y-4">
    //             <div>
    //               <input
    //                 type="email"
    //                 placeholder="Email"
    //                 className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
    //                 value={email}
    //                 onChange={(e) => {
    //                   setEmail(e.target.value);
    //                   setError("");
    //                 }}
    //               />
    //             </div>

    //             <div className="relative">
    //               <input
    //                 type={showPassword ? "text" : "password"}
    //                 placeholder="Password"
    //                 className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
    //                 value={password}
    //                 onChange={(e) => {
    //                   setPassword(e.target.value);
    //                   setError("");
    //                 }}
    //               />
    //               <button
    //                 type="button"
    //                 className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
    //                 onClick={() => setShowPassword(!showPassword)}
    //               >
    //                 {showPassword ? <FaEye /> : <FaEyeSlash />}
    //               </button>
    //             </div>

    //             {error && (
    //               <div className="text-red-500 text-sm flex items-center gap-2">
    //                 <BiError /> {error}
    //               </div>
    //             )}

    //             <div className="flex items-center justify-between">
    //               <label className="flex items-center">
    //                 <input
    //                   type="checkbox"
    //                   className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
    //                 />
    //                 <span className="ml-2 text-sm text-gray-600">
    //                   Remember Me
    //                 </span>
    //               </label>
    //               <Link
    //                 to="/forgetpassword"
    //                 className="text-sm text-indigo-600 hover:text-indigo-500"
    //               >
    //                 Forgot Password?
    //               </Link>
    //             </div>

    //             <button
    //               type="submit"
    //               className="w-full bg-indigo-600 hover:bg-indigo-700 h-11 relative text-white py-5 rounded-md transition duration-200 flex items-center justify-center"
    //               disabled={loginloading}
    //             >
    //               {loginloading ? <BlinkLoader /> : "Sign In"}
    //             </button>
    //           </form>

    //           <div className="mt-6 text-center">
    //             <p className="text-sm text-gray-600">
    //               Don't have an account yet?{" "}
    //               <Link
    //                 to="https://fixall.ai/products/sales/inficonnect/signup"
    //                 className="text-indigo-600 hover:text-indigo-500"
    //               >
    //                 Sign up
    //               </Link>
    //             </p>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>

    <div className="w-[100vw] min-h-screen flex justify-center align-middle items-center p-2 md:p-10">
      <div className="w-full h-full xl:max-h-[600px] md:w-[90%] xl:w-[70%] md:h-[80%] mx-auto border border-slate-300 rounded-xl md:shadow-md ">
        <div className="rounded-lg  md:w-[100%] mx-auto  md:h-screen-xl w-full h-full flex flex-col md:flex-row">
          <div className="w-full md:w-1/2 h-auto  md:flex flex-col  justify-center pr-[5%] items-start hidden ">
            <div
              className=" flex flex-col justify-between h-full relative w-[100%]  rounded-xl"
              style={{
                background:
                  "linear-gradient(156.97deg, #9089FF 14.91%, #CECBFF 58.52%, #FFFFFF 93.18%)",
              }}
            >
              <div className="flex flex-col w-full  justify-start align-middle items-center mt-5 h-full"></div>
              <div className="flex absolute bottom-0 -right-[40%] justify-center w-auto h-[70%]">
                <img src="/loginBackground.png" alt="Logo" className=" " />
              </div>
            </div>
          </div>
          <div className="w-full md:w-1/2 h-full flex flex-col justify-center p-5 items-center">
            <div className="max-w-md">
              <div className="flex  justify-center w-full">
                <img src="/logo.png" alt="Logo" className="h-10 mb-6 " />
              </div>
              <h2 className="text-xl md:text-2xl font-semibold text-center text-gray-800 mb-2">
                Login in to your account
              </h2>
              <p className="text-gray-500 text-center mb-8">
                Please enter your Login ID and Password
              </p>

              <form onSubmit={loginHandler} className="space-y-4">
                <div>
                  <input
                    type="email"
                    placeholder="Email"
                    className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setError("");
                    }}
                  />
                </div>

                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setError("");
                    }}
                  />
                  <button
                    type="button"
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEye /> : <FaEyeSlash />}
                  </button>
                </div>

                {error && (
                  <div className="text-red-500 text-sm flex items-center gap-2">
                    <BiError /> {error}
                  </div>
                )}

                <div className="flex items-center justify-between">
                  <label className="flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 "
                      onClick={handleCheckboxChange}
                    />
                    <span className="ml-2 text-sm text-gray-600">
                      Remember Me
                    </span>
                  </label>
                  <Link
                    to="/forgetpassword"
                    className="text-sm text-indigo-600 hover:text-indigo-500"
                  >
                    Forgot Password?
                  </Link>
                </div>

                <button
                  type="submit"
                  className="w-full bg-indigo-600 hover:bg-indigo-700 h-11 relative text-white py-5 rounded-md transition duration-200 flex items-center justify-center"
                  disabled={loginloading}
                >
                  {loginloading ? <BlinkLoader /> : "Sign In"}
                </button>
              </form>

              <div className="mt-6 text-center">
                <p className="text-sm text-gray-600">
                  Don't have an account yet?{" "}
                  <Link
                    to="https://fixall.ai/products/sales/inficonnect/signup"
                    className="text-indigo-600 hover:text-indigo-500"
                  >
                    Sign up
                  </Link>
                </p>
              </div>
            </div>

            {/* <div className="flex mt-4 gap-4">
              <button className="hover:bg-[#7453E0] border lg:border-2 text-[#7453E0] border-[#7453E0] hover:text-white text-xs lg:text-sm font-semibold px-2 py-2 rounded-md flex items-center justify-center gap-2" onClick={handleDownload}>
                Download APK
                <IoLogoAndroid className="text-base md:text-lg" />
              </button>
              <button className="hover:bg-[#7453E0] border lg:border-2 text-[#7453E0] border-[#7453E0] hover:text-white text-xs lg:text-sm font-semibold px-2 py-2 rounded-md flex items-center justify-center gap-2" onClick={() => toast.error("Currently this is not available.")}>
                Download IPA
                <DiApple className="text-base md:text-lg" />
              </button>
              <Link
                to="https://fixall.ai/request-demo"
                className="text-sm text-indigo-600 hover:text-indigo-500"
              >
                <button className="hover:bg-[#7453E0] border lg:border-2 text-[#7453E0] border-[#7453E0] hover:text-white text-xs lg:text-sm font-semibold px-2 py-2 rounded-md flex items-center justify-center gap-2" onClick={() => toast.error("Currently this is not available.")}>
                  Request demo
                </button>
              </Link>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserLogin;
